import { render } from "./HomeMenuComponent.vue?vue&type=template&id=56ebfd9a&scoped=true"
import script from "./HomeMenuComponent.vue?vue&type=script&lang=js"
export * from "./HomeMenuComponent.vue?vue&type=script&lang=js"

import "./HomeMenuComponent.vue?vue&type=style&index=0&id=56ebfd9a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ebfd9a"]])

export default __exports__